let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jFE9F")).then(() => parcelRequire('f8XV3'));